<template>
    <section v-if="errorDetail" class="info-box-wrapper error">
        <al-message type="error" class="info-box">
            <div class="error-content">
                <p><strong class="front-matter">An error occurred. Please retry, or contact support if the error persists.</strong></p>
                <p class="error-message">{{ errorDetail.message }}: {{ errorDetail.detail }}</p>
            </div>
        </al-message>
    </section>
</template>

<script setup lang="ts">
import { ErrorDetail } from '@/pages/OperationsAdministration/types/ErrorDetail';

defineProps<{ errorDetail: ErrorDetail | undefined }>();
</script>

<style scoped lang="scss">
@use '@/styles/commonPageStyles.scss';
</style>
